import script from "./Messenger.vue?vue&type=script&setup=true&lang=js"
export * from "./Messenger.vue?vue&type=script&setup=true&lang=js"

import "./Messenger.vue?vue&type=style&index=0&id=e1f7b922&scoped=true&lang=css"

import exportComponent from "E:\\WebstormProjects\\sms-transfer-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1f7b922"]])

export default __exports__